<template>
  <section class="section mobile_div section_bg custom_page_v2" >
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <div class="alert alert-warning" v-if="is_load && isdeveloper==false">
      <h2>Доступ запрещен!</h2>
      <p>Данная страница доступна только пользователям, с правами исполнителя!</p>
    </div>
    <div v-if="is_load && isdeveloper==true">
   <div class="section_header mobile_div  d-flex justify-content-center">
     <nav v-if="is_show_choose_category==true" aria-label="breadcrumb"  >
       <router-link tag="a" class="btn" :to="{name: 'home'}"  ><i class="fa fa-backward"></i> Назад</router-link>
     </nav>
     <nav v-if="is_show_choose_category==false" aria-label="breadcrumb" >
       <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link tag="a" :to="{name: 'services'}">
           Услуги
         </router-link></li>
         <li class="breadcrumb-item"><router-link tag="a" :to="{name: 'service_page',params:{service_id:service.last_id}}">
           {{ service.name}}
         </router-link></li>
         <li class="breadcrumb-item active" aria-current="page">Новый проект</li>
       </ol>
     </nav>
   </div>

      <div class="" v-if="is_load && isdeveloper==true">
       <div class="section_header mobile_div nocenter ">
         <h2 class="text-center">Создать проект</h2>
         <div class="container-fluid">



           <editorjsinput  :blocks_json="example_blocks" ref="editorjs" ></editorjsinput>

           <div class="alert alert-danger" v-if="iserror==true">
             <p>{{ error_message }}</p>
           </div>
           <p class="text-center"><button class="btn" @click="onSave" v-if="!(service && service.isform=='1' && service.form_setting && service.form_setting.length>0)"  >Добавить проект</button></p>

         </div>
       </div>
      </div>
    </div>
  </section>
</template>
<script>
import Api from "@/models/Api";
import Editorjsinput from "@/models/Editorjsinput";
import UserModel from "@/models/UserModel";
import Vue from "vue";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import FormService from "@/components/Custom/FormService";


export default {
  name: "AddProject",
  data() {

    var app = this;

    return {

      'newProject':{

        "i_am_client_and_developer":true,


      },
      'example_blocks':[


      ],
      "is_show_choose_category":true,
      'is_load':false,
      'categorys':[],
      'iserror':false,
      'custom_form':{},
      'error_message':'',
      'isdeveloper':false,
      'service':null,
      'btn_title':'Создать проект',





    }
  },
  mounted: function () {
    var app = this;

    Api.loadCategorys(function(categorys){

      app.categorys=categorys;
      app.is_load=true;

      var user=UserModel.get();


      if(user && user.isdeveloper==1){
        app.isdeveloper=true;
      }
    })











  },components: {
    'editorjsinput': Editorjsinput,LoadingBlock,FormService,
  },methods:{
    changeCategory(){
      var app=this;
      var id=app.newProject.category;
      Api.loadAboutService(id,function(data){

        app.service=data.service;
        if(app.service.isform=="1" && app.service.form_setting && app.service.form_setting.length>0){
          var custom_form={};
          app.service.form_setting.forEach(function(elem){

            if(elem.name){
              custom_form[elem.name]="";
            }
          });
          app.custom_form=custom_form;
        }
        app.newProject.category=data.service.last_id;

        app.btn_title='Отправить проект на оценку';
        app.is_load=true;

      },function(){
        app.$router.push({name:'404'});
      })
    },

    onSaveForm(){
      var app=this;
      var result_data=app.$refs.formService.saveForm();
      if(Object.entries(result_data).length>0){
        var newProject=app.newProject;
        app.is_load=false;



        newProject.form =result_data;
        Api.createProject(newProject, function (result) {
          app.is_load=true;
          if (result.iserror == false) {
            app.iserror = false;

            //document.location = "/project/" + result.project_id;
            app.$router.push({name: 'project', params: {id: result.project_id, "rand": Math.random()}});
          } else {
            app.iserror = true;
            app.error_message = result.error_message;
          }
        });
      }


    },
    onSave(){
      var app=this;
      app.is_load=false;
      app.$refs.editorjs.save(function(editor_js_data){

        var newProject=app.newProject;




        newProject.json = editor_js_data;
        Api.createProject(newProject, function (result) {
          app.is_load=true;
          if (result.iserror == false) {
            app.iserror = false;

            //document.location = "/project/" + result.project_id;
            app.$router.push({name: 'project', params: {id: result.project_id, "rand": Math.random()}});
          } else {
            app.iserror = true;
            app.error_message = result.error_message;
          }
        });




      });
    },


  },
}
</script>

<style scoped>

</style>